import React, { useMemo } from "react";

const ServicesPackages = () => {
  const packages = useMemo(
    () => [
      {
        name: "Workshop Sprint",
        tag: "Fast start",
        desc: "Ideal for introducing a consistent problem-solving framework and launching projects.",
        bullets: ["1–2 day workshop", "Templates + tools", "Action plan & cadence"],
        cta: "Request a Sprint",
        href: "/contact"
      },
      {
        name: "30–60 Day Program",
        tag: "Most popular",
        desc: "Structured delivery with coaching and measurable outcomes across teams.",
        bullets: ["Weekly coaching", "Project support", "KPIs + reporting"],
        cta: "Discuss Program",
        href: "/contact",
        featured: true
      },
      {
        name: "Ongoing Support",
        tag: "Sustain",
        desc: "Keep the gains with reinforcement, governance, and continuous improvement routines.",
        bullets: ["Monthly reviews", "Audit readiness", "Training refresh"],
        cta: "Talk to Us",
        href: "/contact"
      }
    ],
    []
  );

  return (
    <section id="packages" className="w-full bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-18 sm:py-20">
        <div className="max-w-2xl">
          <h2 className="text-2xl sm:text-3xl font-semibold text-[color:var(--navy)]">
            Packages that fit your timeline
          </h2>
          <p className="mt-3 text-[color:var(--muted)]">
            Pick a starting point. We tailor delivery to your process maturity and goals.
          </p>
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {packages.map((p) => (
            <div
              key={p.name}
              className={`relative overflow-hidden rounded-2xl border p-7 transition hover:-translate-y-1 hover:shadow-xl ${
                p.featured
                  ? "border-[color:var(--brand)]/30 bg-[color:var(--surface)]"
                  : "border-[color:var(--border)] bg-white"
              }`}
            >
              <div className="absolute -top-28 -right-28 h-64 w-64 rounded-full bg-[color:var(--brand-accent)]/12 blur-3xl" />
              <div className="relative">
                <div className="inline-flex items-center gap-2 rounded-full bg-[color:var(--brand)]/10 px-3 py-1 text-xs font-semibold text-[color:var(--brand)]">
                  {p.tag}
                  {p.featured && (
                    <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--brand-accent)]" />
                  )}
                </div>

                <div className="mt-4 text-xl font-semibold text-[color:var(--navy)]">
                  {p.name}
                </div>

                <p className="mt-3 text-sm text-[color:var(--muted)] leading-relaxed">
                  {p.desc}
                </p>

                <div className="mt-6 grid gap-2">
                  {p.bullets.map((b) => (
                    <div key={b} className="flex items-center gap-2 text-sm text-[color:var(--navy)]/85">
                      <span className="h-2 w-2 rounded-full bg-[color:var(--brand-accent)]" />
                      <span>{b}</span>
                    </div>
                  ))}
                </div>

                <a
                  href={p.href}
                  className={`mt-8 inline-flex w-full items-center justify-center rounded-lg px-5 py-3 text-sm font-semibold transition shadow-sm ${
                    p.featured
                      ? "bg-[color:var(--brand)] text-white hover:opacity-95"
                      : "bg-[color:var(--brand-accent)] text-[color:var(--navy)] hover:brightness-95"
                  }`}
                >
                  {p.cta}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesPackages;
